import setSiteMeta from '../base-saving-actions/set-site-meta';

const createCustomColors = (colors) => setSiteMeta(['customization', 'customColors'], colors);

export default createCustomColors;
